 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"common-password-reset":"common-password-reset","competitor-login":"competitor-login","competitor-members":"competitor-members","competitor-members-add":"competitor-members-add","competitor-members-detail":"competitor-members-detail","competitor-password-reset":"competitor-password-reset","competitor-register":"competitor-register","competitor-works":"competitor-works","competitor-works-add":"competitor-works-add","competitor-works-detail":"competitor-works-detail","dashboard-banners":"dashboard-banners","dashboard-banners-add":"dashboard-banners-add","dashboard-banners-detail":"dashboard-banners-detail","dashboard-competition":"dashboard-competition","dashboard-competition-add":"dashboard-competition-add","dashboard-competition-detail":"dashboard-competition-detail","dashboard-competition-guide~dashboard-mini-article-add~dashboard-news-add":"dashboard-competition-guide~dashboard-mini-article-add~dashboard-news-add","dashboard-competition-guide":"dashboard-competition-guide","dashboard-mini-article-add":"dashboard-mini-article-add","dashboard-news-add":"dashboard-news-add","dashboard-competition-schedule":"dashboard-competition-schedule","dashboard-competition-track":"dashboard-competition-track","dashboard-experts":"dashboard-experts","dashboard-experts-add":"dashboard-experts-add","dashboard-experts-detail":"dashboard-experts-detail","dashboard-experts-lib":"dashboard-experts-lib","dashboard-experts-lib-add":"dashboard-experts-lib-add","dashboard-experts-lib-detail":"dashboard-experts-lib-detail","dashboard-login":"dashboard-login","dashboard-mini-article":"dashboard-mini-article","dashboard-mini-article-detail":"dashboard-mini-article-detail","dashboard-mini-banners":"dashboard-mini-banners","dashboard-mini-banners-add":"dashboard-mini-banners-add","dashboard-mini-banners-detail":"dashboard-mini-banners-detail","dashboard-news":"dashboard-news","dashboard-news-detail":"dashboard-news-detail","dashboard-popup":"dashboard-popup","dashboard-popup-add":"dashboard-popup-add","dashboard-popup-detail":"dashboard-popup-detail","dashboard-works":"dashboard-works","dashboard-works-detail":"dashboard-works-detail","dashboard-works-history":"dashboard-works-history","dashboard-works-history-add":"dashboard-works-history-add","dashboard-works-history-detail":"dashboard-works-history-detail","judge-login":"judge-login","judge-review":"judge-review","judge-review-detail":"judge-review-detail"}[chunkId]||chunkId) + "." + {"common-password-reset":"57d496b7","competitor-login":"99f2e843","competitor-members":"24fbb7d3","competitor-members-add":"d1e76c48","competitor-members-detail":"cb8bda95","competitor-password-reset":"a28dc4e1","competitor-register":"dca1fd77","competitor-works":"b5f1ddf6","competitor-works-add":"1adc6e70","competitor-works-detail":"24d7cd34","dashboard-banners":"8b59018f","dashboard-banners-add":"d87cb163","dashboard-banners-detail":"5887b76c","dashboard-competition":"de71e40a","dashboard-competition-add":"197d831e","dashboard-competition-detail":"a1456700","dashboard-competition-guide~dashboard-mini-article-add~dashboard-news-add":"4c3f00aa","dashboard-competition-guide":"86088608","dashboard-mini-article-add":"c037cf16","dashboard-news-add":"8c632950","dashboard-competition-schedule":"dc5660a8","dashboard-competition-track":"dae15cf8","dashboard-experts":"d183ad23","dashboard-experts-add":"fe73eba8","dashboard-experts-detail":"b25dfe53","dashboard-experts-lib":"3b75ea06","dashboard-experts-lib-add":"aa314ea1","dashboard-experts-lib-detail":"c47ea017","dashboard-login":"1f1bdc61","dashboard-mini-article":"ff289aaa","dashboard-mini-article-detail":"f945bbfb","dashboard-mini-banners":"3d65f77f","dashboard-mini-banners-add":"ff15c230","dashboard-mini-banners-detail":"a2ae6af8","dashboard-news":"575841d8","dashboard-news-detail":"44704668","dashboard-popup":"8a974be0","dashboard-popup-add":"e82c216f","dashboard-popup-detail":"71b90f2d","dashboard-works":"3bab2c4b","dashboard-works-detail":"349ea484","dashboard-works-history":"9469efa0","dashboard-works-history-add":"4cd5e4e3","dashboard-works-history-detail":"ee1cabf1","judge-login":"7fdb50fc","judge-review":"5795831d","judge-review-detail":"af2c0d14"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"common-password-reset":1,"competitor-login":1,"competitor-members-add":1,"competitor-members-detail":1,"competitor-register":1,"competitor-works-add":1,"competitor-works-detail":1,"dashboard-banners-add":1,"dashboard-banners-detail":1,"dashboard-competition-add":1,"dashboard-competition-detail":1,"dashboard-competition-guide~dashboard-mini-article-add~dashboard-news-add":1,"dashboard-competition-schedule":1,"dashboard-experts-detail":1,"dashboard-experts-lib-add":1,"dashboard-experts-lib-detail":1,"dashboard-login":1,"dashboard-mini-article-detail":1,"dashboard-mini-banners-add":1,"dashboard-mini-banners-detail":1,"dashboard-news-detail":1,"dashboard-popup-detail":1,"dashboard-works-detail":1,"dashboard-works-history-add":1,"dashboard-works-history-detail":1,"judge-login":1,"judge-review":1,"judge-review-detail":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"common-password-reset":"common-password-reset","competitor-login":"competitor-login","competitor-members":"competitor-members","competitor-members-add":"competitor-members-add","competitor-members-detail":"competitor-members-detail","competitor-password-reset":"competitor-password-reset","competitor-register":"competitor-register","competitor-works":"competitor-works","competitor-works-add":"competitor-works-add","competitor-works-detail":"competitor-works-detail","dashboard-banners":"dashboard-banners","dashboard-banners-add":"dashboard-banners-add","dashboard-banners-detail":"dashboard-banners-detail","dashboard-competition":"dashboard-competition","dashboard-competition-add":"dashboard-competition-add","dashboard-competition-detail":"dashboard-competition-detail","dashboard-competition-guide~dashboard-mini-article-add~dashboard-news-add":"dashboard-competition-guide~dashboard-mini-article-add~dashboard-news-add","dashboard-competition-guide":"dashboard-competition-guide","dashboard-mini-article-add":"dashboard-mini-article-add","dashboard-news-add":"dashboard-news-add","dashboard-competition-schedule":"dashboard-competition-schedule","dashboard-competition-track":"dashboard-competition-track","dashboard-experts":"dashboard-experts","dashboard-experts-add":"dashboard-experts-add","dashboard-experts-detail":"dashboard-experts-detail","dashboard-experts-lib":"dashboard-experts-lib","dashboard-experts-lib-add":"dashboard-experts-lib-add","dashboard-experts-lib-detail":"dashboard-experts-lib-detail","dashboard-login":"dashboard-login","dashboard-mini-article":"dashboard-mini-article","dashboard-mini-article-detail":"dashboard-mini-article-detail","dashboard-mini-banners":"dashboard-mini-banners","dashboard-mini-banners-add":"dashboard-mini-banners-add","dashboard-mini-banners-detail":"dashboard-mini-banners-detail","dashboard-news":"dashboard-news","dashboard-news-detail":"dashboard-news-detail","dashboard-popup":"dashboard-popup","dashboard-popup-add":"dashboard-popup-add","dashboard-popup-detail":"dashboard-popup-detail","dashboard-works":"dashboard-works","dashboard-works-detail":"dashboard-works-detail","dashboard-works-history":"dashboard-works-history","dashboard-works-history-add":"dashboard-works-history-add","dashboard-works-history-detail":"dashboard-works-history-detail","judge-login":"judge-login","judge-review":"judge-review","judge-review-detail":"judge-review-detail"}[chunkId]||chunkId) + "." + {"common-password-reset":"1dd6d24d","competitor-login":"bd87a756","competitor-members":"31d6cfe0","competitor-members-add":"8797cc9f","competitor-members-detail":"4b8ebf15","competitor-password-reset":"31d6cfe0","competitor-register":"93fe8f19","competitor-works":"31d6cfe0","competitor-works-add":"a47f0966","competitor-works-detail":"15cb8cdf","dashboard-banners":"31d6cfe0","dashboard-banners-add":"a47f0966","dashboard-banners-detail":"09327383","dashboard-competition":"31d6cfe0","dashboard-competition-add":"a47f0966","dashboard-competition-detail":"f452df47","dashboard-competition-guide~dashboard-mini-article-add~dashboard-news-add":"55c46882","dashboard-competition-guide":"31d6cfe0","dashboard-mini-article-add":"31d6cfe0","dashboard-news-add":"31d6cfe0","dashboard-competition-schedule":"a47f0966","dashboard-competition-track":"31d6cfe0","dashboard-experts":"31d6cfe0","dashboard-experts-add":"31d6cfe0","dashboard-experts-detail":"60acccb6","dashboard-experts-lib":"31d6cfe0","dashboard-experts-lib-add":"a47f0966","dashboard-experts-lib-detail":"c841d4f0","dashboard-login":"321af111","dashboard-mini-article":"31d6cfe0","dashboard-mini-article-detail":"2b68d6e7","dashboard-mini-banners":"31d6cfe0","dashboard-mini-banners-add":"a47f0966","dashboard-mini-banners-detail":"3c983693","dashboard-news":"31d6cfe0","dashboard-news-detail":"d39dcd9d","dashboard-popup":"31d6cfe0","dashboard-popup-add":"31d6cfe0","dashboard-popup-detail":"5ee9c1a6","dashboard-works":"31d6cfe0","dashboard-works-detail":"e632838c","dashboard-works-history":"31d6cfe0","dashboard-works-history-add":"a47f0966","dashboard-works-history-detail":"74cbfbc4","judge-login":"06a69d1e","judge-review":"3bedfac5","judge-review-detail":"875c45b2"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
